import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    document.title = '911爆料网 | 911爆料吃瓜与911吃瓜爆料网最新热点八卦事件追踪';
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '911爆料网',
    url: window.location.origin,
    description: '911爆料网专注吃瓜内容，汇集911吃瓜最新热点、八卦事件与吃瓜素材，一站式浏览各类911爆料吃瓜合集。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: window.location.origin + '?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '911爆料网的内容来源是什么？信息可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '911爆料网的内容来源于多个渠道，包括用户匿名投稿、社交媒体公开信息整理、以及编辑团队对网络热点事件的追踪和梳理。我们对每一条发布的信息都会进行多方交叉验证，标注信息来源和可信度等级。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在911爆料网投稿爆料？我的隐私安全吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过本站"爆料投稿"模块选择邮箱投稿或微信投稿两种方式。我们承诺对所有投稿默认采用匿名处理机制，不记录投稿人的IP地址、设备信息等任何个人身份数据。',
        },
      },
      {
        '@type': 'Question',
        name: '911爆料网的内容更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们保持7x24小时全天候运营，编辑团队实时追踪全网热点动态。重大事件发生后30分钟内即可看到初步报道。建议关注我们的微信公众号或微博账号获取每日精选推送。',
        },
      },
      {
        '@type': 'Question',
        name: '如果在911爆料网上看到不实信息怎么办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们设立了专门的纠错与反馈通道。你可以通过"爆料投稿"模块中的任意联系方式与我们取得联系。我们会在收到反馈后24小时内启动核实程序，确认属实后立即进行更正或删除。',
        },
      },
      {
        '@type': 'Question',
        name: '911爆料网的内容是否免费？需要注册吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '911爆料网目前所有内容均为免费浏览，不需要注册账号。我们致力于打造一个开放、自由的信息聚合平台，让每一位吃瓜群众都能无障碍地获取最新爆料资讯。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />

      <Header />

      <main>
        <Hero />
        <About />
        <MediaSection />
        <IndexSection />
        <TopicsSection />
        <CarouselSection />
        <AppSection />
        <UpdatesSection />
        <ContactSection />
        <FeaturesSection />
        <CardsSection />
        <CommentsSection />
        <RankingSection />
        <FaqSection />
      </main>

      <Footer />
    </>
  );
}